import { render, staticRenderFns } from "./ResponsiveImage.vue?vue&type=template&id=c8201af2&"
import script from "./ResponsiveImage.vue?vue&type=script&lang=js&"
export * from "./ResponsiveImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kristiankalva/Local Sites/ensign-boligprosjekter/app/public/wp-content/plugins/ensign-boligprosjekter/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8201af2')) {
      api.createRecord('c8201af2', component.options)
    } else {
      api.reload('c8201af2', component.options)
    }
    module.hot.accept("./ResponsiveImage.vue?vue&type=template&id=c8201af2&", function () {
      api.rerender('c8201af2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ResponsiveImage.vue"
export default component.exports